import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Activity, AlertCircle } from 'lucide-react';
export function HookSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-227">
      <div className="max-w-3xl mx-auto" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl leading-relaxed text-brand-gray" data-id="element-229">
          <div className="flex gap-4 items-start bg-brand-cream p-6 rounded-2xl border border-brand-gold/20" data-id="element-230">
            <Moon className="w-8 h-8 text-brand-gold flex-shrink-0 mt-1" data-id="element-231" />
            <p data-id="element-232">
              ¿Te despiertas a las 3 de la mañana con el pijama empapado, el
              corazón acelerado y una ansiedad que no puedes explicar?
            </p>
          </div>

          <div className="flex gap-4 items-start p-6" data-id="element-233">
            <Activity className="w-8 h-8 text-brand-green flex-shrink-0 mt-1" data-id="element-234" />
            <p data-id="element-235">
              ¿Te miras al espejo y no reconoces ese abdomen que parece haber
              aparecido de la noche a la mañana?
            </p>
          </div>

          <div className="flex gap-4 items-start bg-brand-cream p-6 rounded-2xl border border-brand-gold/20" data-id="element-236">
            <AlertCircle className="w-8 h-8 text-brand-red flex-shrink-0 mt-1" data-id="element-237" />
            <p data-id="element-238">
              Si sientes que "comer menos y moverte más" ya no funciona para
              ti... tengo una noticia que cambiará tu vida:
            </p>
          </div>

          <div className="text-center pt-8" data-id="element-239">
            <h3 className="text-3xl md:text-4xl font-bold text-brand-green mb-2" data-id="element-240">
              No eres tú.
            </h3>
            <p className="text-2xl md:text-3xl font-heading italic text-brand-gold" data-id="element-241">
              Son tus hormonas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}